import { DONATE_CLASSES } from '../constants/classNames';
import { DONATE_URL, IS_SUPPORT_BUTTON_VISIBLE } from '../constants/config';
import { joinClassNames } from '../utils/classNameUtils';
import '../styles/DonateButton.css';

export default function DonateButton({ label = 'Support Us', className = '' }) {
  if (!IS_SUPPORT_BUTTON_VISIBLE) return null;

  return (
    <a
      className={joinClassNames(DONATE_CLASSES.button, className)}
      href={DONATE_URL}
      target="_blank"
      rel="noopener noreferrer"
    >
      <span className={DONATE_CLASSES.icon} aria-hidden="true">♥</span>
      {label}
    </a>
  );
}
